import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './filtered-community-product.action';
import { CommunityProduct } from '../../models/community-product.model';

export interface ErrorPayload {
  message: string;
  statusCode: number;
}

export interface ProductState {
  filteredProducts: CommunityProduct[];
  loading: boolean;
  error: ErrorPayload | null;
}

export const initialState: ProductState = {
  filteredProducts: [],
  loading: false,
  error: null,
};

export const filteredCommunityProductReducer = createReducer(
  initialState,

  // When loading filtered products
  on(ProductActions.loadFilteredCommunityProducts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // On successful product load
  on(ProductActions.loadFilteredCommunityProductsSuccess, (state, { filteredProducts }) => ({
    ...state,
    filteredProducts,
    loading: false,
  })),

  // On failed product load
  on(ProductActions.loadFilteredCommunityProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
